module.exports = __webpack_public_path__ + "static/media/car.1e5c289d.jpg";